import { render } from "./BarGraphOptions.vue?vue&type=template&id=c3818f7a"
import script from "./BarGraphOptions.vue?vue&type=script&lang=js"
export * from "./BarGraphOptions.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__